import { render, staticRenderFns } from "./VerifyResetPassword.vue?vue&type=template&id=011d6518&scoped=true&"
import script from "./VerifyResetPassword.vue?vue&type=script&lang=js&"
export * from "./VerifyResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011d6518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('011d6518')) {
      api.createRecord('011d6518', component.options)
    } else {
      api.reload('011d6518', component.options)
    }
    module.hot.accept("./VerifyResetPassword.vue?vue&type=template&id=011d6518&scoped=true&", function () {
      api.rerender('011d6518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/VerifyResetPassword.vue"
export default component.exports